/**
 * Created by yangyue on 2017/9/1.
 */
let env = process.env.NODE_ENV || 'development'

let index
if (env === 'development') {
  index = require('./dev')
} else {
  index = require('./prod')
}

module.exports = index



// WEBPACK FOOTER //
// ./src/configs/index.js